<template>
  <div class="relative h-full max-h-full w-full max-w-full">
    <Line
      v-if="Array.isArray(chartData.datasets)"
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<script>
// https://vue-chartjs.org/examples/
import { Line } from 'vue-chartjs'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export default {
  name: 'LineChar',
  components: {
    Line
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    groupBy: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            display: false
          }
        }
      }
    }
  },
  watch: {
    groupBy(newVal) {
      // Update the chart options reactively when groupBy changes
      this.chartOptions.scales.x.display = newVal === 'periode'
    }
  }
}
</script>

<style scoped></style>
